'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _LogoSpinner = require('../../components/loaders/LogoSpinner');

var _LogoSpinner2 = _interopRequireDefault(_LogoSpinner);

var _socketConstants = require('../../utils/socket/socketConstants');

require('./SocketConnectionStatusError.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
var SocketConnectionStatusError = function SocketConnectionStatusError(props) {
    var socketConnection = props.socketConnection;


    if (socketConnection.get('status') !== _socketConstants.SOCKET_CONNECTION_STATUS.DISCONNECTED) return null;

    return _react2.default.createElement(
        'div',
        { className: 'SocketConnectionStatusError' },
        _react2.default.createElement(_LogoSpinner2.default, null),
        _react2.default.createElement(
            'p',
            null,
            'Reconnecting'
        )
    );
};

// Styles


// Components


SocketConnectionStatusError.propTypes = {
    socketConnection: _propTypes2.default.object
};

exports.default = (0, _recompose.pure)(SocketConnectionStatusError);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/SocketConnectionStatusError.js
// module id = 1757
// module chunks = 0